import Vue from "@/proyectos/mate/main";
export default Vue;